import type { ModelInfo } from "@/types";
import { getActiveProvider } from "../providers";

/** Fetch the installed model list from the active provider. Thin wrapper —
 * the seam exists so `modelsStore` doesn't reach into `providers` directly. */
export async function fetchInstalledModels(baseUrl: string): Promise<ModelInfo[]> {
  return getActiveProvider().listModels(baseUrl);
}
